<template>
  <v-card class="mx-auto mt-6" max-width="500">
    <v-card-title class="pa-8 mb-4">
      <v-img src="@/assets/logo.png" height="200" contain></v-img>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" @submit.prevent="login">
        <v-text-field
          v-model="emailAddress"
          :rules="[rules.required, rules.emailAddress]"
          type="email"
          label="Email Address"
          required
          prepend-icon="mdi-account-circle"
        ></v-text-field>
        <v-text-field
          v-model="password"
          :rules="[rules.required]"
          type="password"
          label="Password"
          required
          prepend-icon="mdi-lock"
        ></v-text-field>
        <forgotten-password></forgotten-password>
        <v-btn
          class="d-block mt-4"
          type="submit"
          dark
          color="primary"
          width="100%"
          :loading="loading"
          >Log In</v-btn
        >
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import ForgottenPassword from '@/components/ForgottenPassword.vue'
import Validation from '@/mixins/validation.js'

export default {
  name: 'Login',
  components: {
    ForgottenPassword
  },
  mixins: [Validation],
  data() {
    return {
      valid: true,
      emailAddress: '',
      password: '',
      loading: false
    }
  },
  methods: {
    login() {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.$store
          .dispatch('login', {
            emailAddress: this.emailAddress,
            password: this.password
          })
          .then(() => {
            this.$router.push({ name: 'home' })
          })
          .catch(() => {
            alert('Username or password was incorrect')
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>

<style scoped></style>
